<!--
@Author: Calvin Green <calvin>
@Date:   2021-12-21T16:03:05+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-05-12T20:36:36+02:00
@Copyright: Diversitude 2021
-->



<template>
    <div>
        <b-row>
            <b-col cols="12" v-if="false">
                <BreadCrumbs/>
            </b-col>
            <!--<b-col cols="6">
                <div class="card" style="overflow-x: auto;">
                    <span class="badge bg-danger rounded-pill badge-header">{{admin_notification_count}}</span>
                    <div style="width:fit-content; color: #ffffff;  border-radius: 0.2rem;" class="text-light card-title card ccb_green p-2">Client Notifications</div>
                    <span style="display: inline-flex;">
                        <div
                        :title="notification.name"
                        class="m-1 p-1 info-tile"
                        v-for="notification in client_notifications" :key="notification.id">
                            <div style="width: 100%; text-align: center;">
                                <span class="badge bg-danger rounded-pill badge-tile">{{notification.count}}</span>
                                <i style="font-size: 2rem;" class="fas fa-file"></i>
                            </div>
                            <div>
                                <p style="text-align: center;" class="text-truncate">{{notification.name}}</p>
                            </div>
                        </div>
                    </span>
                </div>
            </b-col>-->
            <b-col cols="6">
                <div class="card" style="overflow-x: auto;">
                    <span style="" class="badge bg-danger rounded-pill badge-header">{{admin_notification_count}}</span>
                    <div style="width:fit-content; color: #ffffff;" class="card-title card ccb_green p-2">Admin Notifications</div>
                    <div style="display: inline-flex;">
                        <div
                        :title="notification.name"
                        class="m-1 p-1 info-tile"
                        style="text-align: center; position: relative;"
                        :class="notification.length == 0 ? 'no-notification' : ''"
                        @click="selectNotification(notification, idx)"
                        v-for="(notification, idx) in notification_data" :key="notification.id">
                            <span style="" class="badge bg-danger rounded-pill notification_count">{{notification.length}}</span>
                            <!--<span style="text-align: center; display: absolute; float: right;">{{notification.length}}</span>-->
                            <div :class="selectedNotificationIndex == idx ? 'selected-notification' : ''" style="width: 100%; text-align: center;">
                                <i style="font-size: 2rem;" class="fas" :class="notification.icon"></i>
                            </div>
                            <div>
                                <p class="text-capitalize text-truncate">{{notification.name}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row v-if="showNotifications == false">
            <b-col>
                <b-card v-if="hasSopGroupSelected">
                    <b-row>
                        <b-col cols="12" class="ps-3 pe-3" style="display: flex;">
                            <b-button @click="searchFilter" variant="outline-primary" class="me-1">
                                <i class="fas fa-search"></i>
                            </b-button>
                            <b-button v-if="search_text !== ''" @click="search_text = ''" variant="warning" class="me-1">
                                <i class="fas fa-times"></i>
                            </b-button>
                            <b-form-input v-model="search_text" style="width: 50rem;"></b-form-input>
                        </b-col>
                    </b-row>
                    <b-overlay :show="show_overlay">
                        <div>
                            <span style="display: inline-flex; flex-wrap: wrap;"
                            id="tester">
                                <div
                                @contextmenu.prevent="clicker($event, doc.id)"
                                @click="selectedDocument(doc.id)"
                                :title="doc.name"
                                class="document-tile"
                                :class="doc.id == last_saved_sop_id ? 'new-tile':''"
                                :id="'doc'+doc.id"
                                v-for="doc in documents" :key="doc.id">
                                    <SopCard :name="doc.name" :code="doc.sop_code" />
                                </div>

                                <div @click="showSopDialog" class="m-2 p-2 document-add-tile" style="text-align: center;">
                                    <i style="font-size: 4rem;" class="fas fa-plus"></i>
                                </div>
                            </span>
                        </div>
                    </b-overlay>
                </b-card>
                <b-card v-else>
                    <b-alert show>
                        Select a SOP group
                    </b-alert>
                </b-card>
            </b-col>

        </b-row>
        <b-row v-if="showNotifications">
            <b-col cols="12">
                <b-card>
                    <!-- @selectedDocument="openDocumentFromNotification"
                    @selectedDocumentNotification="selectedDocument"
                    @viewDistributionRequest="showDistribution"
                    -->
                    <NotificationsTable

                    @back="clearSelectedNotification"
                    :group_notifications="selectedNotification"/>
                </b-card>
            </b-col>
        </b-row>
        <div @blur="hidePopper" tabindex="-1" @click="hidePopper" ref="contextPopper" id="poptest" v-show="showPopper">
            <ContextMenu @action="actionHandler" @close="hidePopper"/>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import { sopAdminState, sopAdminMethods} from '@/state/helpers.js'
import Swal from 'sweetalert2'
import { createPopper } from '@popperjs/core';
import BreadCrumbs from '@/components/widgets/breadcrumbs.vue'
import ContextMenu from "@/components/widgets/contextDocuments";
import SopCard from '@/components/widgets/misc/sopCard.vue'
import NotificationsTable from '@/components/client_admin/sop/notificationsTable.vue';
export default {
    data:() => ({
        showNotifications: false,
        selectedNotification: null,
        selectedNotificationIndex: null,

        search_text: '',
        show_overlay: false,

        last_saved_sop_id: null,

        debug: null,
        showPopper: false,
        popper_id: null,
    }),
    computed:{
        ...sopAdminState,
        hasSopGroupSelected(){
            if(this.selected_sop_group == null){
                return false;
            }
            else{
                return true;
            }
        },
        documents(){
            if(this.sops == null){
                return [];

            }
            else{
                if(this.search_text === ''){
                    return this.sops.sop_types;
                }
                else{
                    let data = _.cloneDeep(this.sops.sop_types);
                    data = _.filter(data, function(o){
                        let valid = false;
                        let doc_name = o.name.toLowerCase();
                        let doc_code = o.sop_code.toLowerCase();
                        let text = window.inst.search_text.toLowerCase()
                        if(doc_name.includes(text) || doc_code.includes(text)){
                            valid = true;
                        }
                        return valid;
                    });
                    return data;
                }
            }
        },
        admin_notification_count(){
            let count = 0;
            this.notification_data.forEach( notification_group => {
                count += notification_group.length;
            })
            return count;
        },
        client_notification_count(){
            if(this.client_notifications.length > 0){
                let total = 0;
                this.client_notifications.forEach((item)=>{
                    total += Number(item.count);
                });
                return total;
            }
            else{
                return 0
            }
        },
        notification_data(){
            let data = [];
            if(this.notifications != null){
                for (const key of Object.keys(this.notifications)) {
                    let item = {
                        name: _.replace(key, '_alerts', ''),
                        length: this.notifications[key].length,
                        icon: this.getIconType(key)
                    }
                    data.push(item);
                }
            }
            console.log(data);
            return data;
        },
    },
    components:{
        ContextMenu,
        BreadCrumbs,
        SopCard,
        NotificationsTable,
    },
    methods:{
        ...sopAdminMethods,
        searchFilter(){

        },
        selectNotification(notification, index){
            console.log('Notification group ' + index);
            let key = notification.name + '_alerts'
            this.selectedNotification = this.notifications[key];
            this.selectedNotificationIndex = index;
            this.showNotifications = true;
        },
        clearSelectedNotification(){
            this.showNotifications = false;
            this.selectedNotification = null;
            this.selectedNotificationIndex = null;
        },
        selectedDocument(id){
            this.clearSopStore();
            this.show_overlay = true;
            this.loadSopData(id)
            .then(()=>{
                this.$emit('edit', id);
                this.show_overlay = false;
            })
            .catch((e)=>{
                console.log(e);
                this.show_overlay = false;
                //alert('Fetching data error')
            })
        },

        async showSopDialog(is_new = true){
            let title_text = '';
            let alert_title = '';
            if(is_new){
                alert_title = "Create new document";
            }
            else{
                title_text = this.findSopById(this.popper_id);
                alert_title = `Edit document`
            }

            this.clearSopStore();

            //* Create Sweetalert input dialog
            const { value: name } = await Swal.fire({
                title: alert_title,
                input: 'textarea',
                inputValue: title_text,
                inputPlaceholder: 'Enter document title',
                showCancelButton: true,
            })
            if (name) {
                this.show_overlay = true;
                let params = {
                    id: -1,
                    sop_group_id: this.selected_sop_group,
                    name: name,
                    sop_code: 'SOP-00'
                }
                //* Save sop, refresh sop group and add a default revision to the new sop
                this.saveSopType(params)
                .then((response)=>{
                    this.loadSops(this.selected_sop_group)
                    .then(()=>{
                        //* last saved id is used to set the document tile css
                        this.last_saved_sop_id = response.id;
                        this.insertFirstRevision(response.id);
                        this.show_overlay = false;
                    })

                })
            }

        },
        insertFirstRevision(id){
            let sop_type_id = id;

            let params = {
                sop_type_id: sop_type_id,
                sections:[
                    {
                        section_id: 'list_of_abbreviations',
                        section_order: 1,
                        body: '<p></p>',
                        section_title: 'Abbreviations',
                        content_height: '',
                    },
                    {
                        section_id: 'objective',
                        section_order: 2,
                        body: '<p></p>',
                        section_title: 'Objective',
                        content_height: '',
                    },
                    {
                        section_id: 'scope',
                        section_order: 3,
                        body: '<p></p>',
                        section_title: 'Scope',
                        content_height: '',
                    },
                    {
                        section_id: 'responsibility',
                        section_order: 4,
                        body: '<p></p>',
                        section_title: 'Responsibility',
                        content_height: '',
                    },
                    {
                        section_id: 'policy',
                        section_order: 5,
                        body: '<p></p>',
                        section_title: 'Policy',
                        content_height: '',
                    },
                    {
                        section_id: 'procedure',
                        section_order: 6,
                        body: '<p></p>',
                        section_title: 'Procedure',
                        content_height: '',
                    },
                    {
                        section_id: 'attachments_annexures',
                        section_order: 7,
                        body: '<p></p>',
                        section_title: 'Attachments',
                        content_height: '',
                    }
                ]
            }


            this.saveSopRevision(params)
            .then(()=>{
                Swal.fire({
                    toast: true,
                    position: 'top',
                    iconColor: 'white',
                    icon: 'success',
                    title:'Saved!',
                    customClass: {     popup: 'success-toast' },
                    showConfirmButton: false,
                    timer: 1500,
                    //timer: 2000, timerProgressBar: true
                });
            })
        },
        clicker(event, id){
            //set id of right clicked document
            this.popper_id = id;

            this.hidePopper();
            this.$nextTick(()=>{
                this.showPopper = true;
                const doc = document.querySelector('#doc'+id)
                const popper = document.querySelector('#poptest')

                this.$nextTick(()=>{
                    this.debug = createPopper(doc, popper,{
                        placement: 'auto'
                    });
                    setTimeout(()=>{
                        if(this.$refs.contextPopper != undefined){
                            this.$refs.contextPopper.focus();
                        }
                    }, 250);
                })
            })


        },
        hidePopper(){
            if(this.debug != null){
                this.debug.destroy();
            }
            this.showPopper = false;
        },
        actionHandler(type){
            //* set document id for the component that is about to be displayed
            this.setContextMenuID(this.popper_id);

            //* handle action
            switch(type){
                case 'stats':{
                    this.show_overlay = true;
                    this.loadSopStats({id:this.popper_id})
                    .then(()=>{
                        this.show_overlay = false;
                        this.$emit('showStats')
                    })
                    .catch(()=>{
                        this.show_overlay = false;
                    })
                    break;
                }
                case 'delete':{
                    this.deleteSopType({id: this.popper_id})
                    .then(()=>{
                        Swal.fire("Deleted!", "Your file has been deleted.", "success");
                        this.loadSops(this.selected_sop_group);
                    })
                    break;
                }
                case 'distribute':{
                    this.$emit('showDistribution');
                    break;
                }
                case 'edit':{
                    let is_new = false;
                    this.showSopDialog(is_new);
                    break;
                }
                default:{
                    console.log('Action ' + type + 'not yet supported');
                    break;
                }
            }
        },
        getIconType(key){
            if(key === 'document_alerts'){
                return 'fa-file'
            }
            if(key === 'facility_alerts'){
                return 'fa-building'
            }
            if(key === 'training_alerts'){
                return 'fa-people-carry'
            }
            if(key === 'action_alerts'){
                return 'fa-bell'
            }
            if(key === 'applicant_alerts'){
                return 'fa-chalkboard-teacher'
            }
        },
    },
    mounted(){
        window.inst = this;
        this.$eventHub.$on('addNewSop', this.showSopDialog);
        this.$eventHub.$on('openDocument', this.selectedDocument);
        this.loadNotifications();
        /*let params = {
            id: -1,
            sop_group_id: 2,
            name: 'First SOP',
            sop_code: 'SOP-000'
        }
        this.saveSopType(params);*/
    },
    beforeDestroy(){
        window.inst = undefined;
        this.$eventHub.$off('addNewSop');
        this.$eventHub.$off('openDocument');
    }
}
</script>

<style>

</style>
